import TanStackTable from "root/TanstackTables/TanStackTable";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import IconTooltip from "ui/Tooltip/IconTooltip";
import React from "react";

const WritebackStatusToolTable = ({data}) =>
{

    const isLoading = false;

    const actionFormatter = (info) =>
    {
        const row = info.row.original;

        return <div className="action-buttons">
            <IconTooltip icon='glyphicon-edit' placement='top' text="Manage (Not available)" onClick={() => console.log("Manage")} color={'grey'}/>
        </div>
    }

    const processedStatusFormatter = (info) =>
    {
        const row = info.row.original;

        switch (row.processed_status)
        {
            default:
            case 0:
                return <IconTooltip icon={'glyphicon-info-sign'} color={'orange'} placement='top' text={'Not processed'}/>
            case 1:
                return <IconTooltip icon={'glyphicon-info-sign'} color={'green'} placement='top' text={'Processed'}/>
            case 2:
                return <IconTooltip icon={'glyphicon-info-sign'} color={'red'} placement='top' text={'Processed'}/>

        }
    }

    const columns = [
        {accessorKey: 'wonde_webhook_id', header: 'ID', enableSorting: false},
        {accessorKey: 'writeback_id', header: 'Writeback ID', enableSorting: true},
        {accessorKey: 'payload_type', header: 'Payload Type', enableSorting: true},
        {accessorKey: 'status', header: 'Status', enableSorting: true},
        {accessorKey: 'school_name', header: 'School', enableSorting: true},
        {accessorKey: 'group_name', header: 'Group Name', enableSorting: true},
        {accessorKey: 'date_created', header: 'Date & Time', enableSorting: true},
        {accessorKey: 'ampmInd', header: 'Registration Session', enableSorting: true},
        {accessorKey: 'processed_status', header: 'Indicator', enableSorting: true, meta: {textAlign: 'center'}, cell: processedStatusFormatter},
        {accessorKey: 'process_failure_message', header: 'Failure message', enableSorting: true},
        {accessorKey: 'actions', header: 'Actions', enableSorting: false, meta: {textAlign: 'center'}, cell: actionFormatter}
    ];

    return (
        <div className='user-edit-table' key='writebackstatustable'>
            {isLoading === false && <TanStackTable data={data} columns={columns} showSearch={true}/>}
            {isLoading === true && <SpinnerDiv/>}
        </div>
    )
}

export default WritebackStatusToolTable;